module.exports = {
  title: 'APP开屏页',
  route: {
    path: '/app-manage',
    children: {
      path: 'app-screen-manage',
    },
  },
};
